<template>
  <v-container>
    <v-row>
      <v-col>
        <TablePicker
          title="Data Table"
          v-model="value.table"
          :required="true"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <FilterDesigner
          :table="value.table"
          title="Data Filter"
          v-model="value.filters"
          :component="component"
          :containers="containers"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <DataOutputPicker title="Save output to" v-model="value.output" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TablePicker from "../shared/TablePicker.vue";
import FilterDesigner from "../shared/FilterDesigner.vue";
import DataOutputPicker from "../shared/DataOutputPicker.vue";

export default {
  name: "GetDataDesigner",

  components: { TablePicker, FilterDesigner, DataOutputPicker },

  props: ["value", "containers", "table", "component"],
};
</script>
